import { render, staticRenderFns } from "./LomTrainingSettingCreate.vue?vue&type=template&id=35555ebe"
import script from "./LomTrainingSettingCreate.vue?vue&type=script&lang=js"
export * from "./LomTrainingSettingCreate.vue?vue&type=script&lang=js"
import style0 from "./LomTrainingSettingCreate.vue?vue&type=style&index=0&id=35555ebe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports